import React, { useState } from 'react'
import { Section, BlogButton, BlogPostCard, Link } from 'newComponents'
import './styles.scss'

const PostGrid = (props) => {
  const {
    posts,
    // containerClassName,
    className,
    title,
    navLinks,
    showExcerpt,
    hasFeaturedPost,
    paginationAmount = 9999
  } = props

  // State
  const [numOfPosts, setNumOfPost] = useState(paginationAmount)
  const [reachedEnd, setReachedEnd] = useState(false)

  if (!posts) return null

  // pagination logic
  const onLoadMore = (event) => {
    event.preventDefault()
    setNumOfPost(numOfPosts + paginationAmount)
    if (numOfPosts + paginationAmount > posts.length) {
      setReachedEnd(true)
    }
  }

  const vericalLayout = title === 'Latest Posts' ? 'latest-posts' : ''
  const limitPosts = className === 'suggested-variant' ? posts.slice(0, 6) : posts
  // const category = title ? title.toLowerCase().replace(/ /g, '-') : null
  return (
    <Section className={`post-grid ${className || ''}`} noWrapper>
      {title && (
        <div className="post-grid-header-container">
          <span className="post-grid-title">{title}</span>
        </div>
      )}
      {navLinks && (
        <div className="post-grid-navlinks">
          {navLinks.map((navLink) => (
            <Link to={navLink.to} key={navLink.to} className="post-grid-navlink">
              {navLink.text}
            </Link>
          ))}
        </div>
      )}
      <div className={`post-grid-container ${className || vericalLayout || ''}`}>
        {limitPosts.length > 0 &&
          limitPosts
            .slice(0, numOfPosts)
            .map((post, index) => (
              <BlogPostCard
                key={post?.data?.title?.text}
                data={post?.data}
                uid={post?.uid}
                className={className}
                index={index}
                showExcerpt={showExcerpt || (hasFeaturedPost && index === 0)}
              />
            ))}
      </div>
      {/* // LOAD MORE BUTTON */}
      {posts.length > 12 && !reachedEnd && (
        <BlogButton to="#more" type="button" onClick={onLoadMore} className="post-grid-button" removeBlogPath>
          LOAD MORE
        </BlogButton>
      )}
    </Section>
  )
}
export default PostGrid
